import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { useAuth } from '../context/AuthContext';
import { PhoneStep, OtpStep } from './auth/AuthSteps';
import { useAuthFlow } from './auth/useAuthFlow';

export default function AuthModal() {
  const { authOpen, setAuthOpen } = useAuth();

  const flow = useAuthFlow(() => setAuthOpen(false));

  useEffect(() => {
    if (!authOpen) {
      const t = setTimeout(() => flow.reset(), 200);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [authOpen, flow]);

  return (
    <Dialog open={authOpen} onOpenChange={setAuthOpen}>
      <DialogContent className="sm:max-w-[440px] p-0 overflow-hidden">
        <div className="p-6 pb-2">
          <DialogHeader>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#1a1d1a] text-white flex items-center justify-center font-bold">F</div>
              <div>
                <DialogTitle className="text-[18px]">Connexion à Fodindin</DialogTitle>
                <DialogDescription className="text-[12.5px]">Sécurisé par code à usage unique</DialogDescription>
              </div>
            </div>
          </DialogHeader>
        </div>

        {flow.step === 'phone' ? (
          <PhoneStep
            phone={flow.phone}
            setPhone={flow.setPhone}
            name={flow.name}
            setName={flow.setName}
            sending={flow.sending}
            onSubmit={flow.sendOtp}
          />
        ) : (
          <OtpStep
            normalizedPhone={flow.normalizedPhone}
            otp={flow.otp}
            setOtp={flow.setOtp}
            verifying={flow.verifying}
            verifyOtp={flow.verifyOtp}
            onBack={() => flow.setStep('phone')}
            resendIn={flow.resendIn}
            onResend={flow.sendOtp}
            sending={flow.sending}
            smsMock={flow.smsMock}
            devCode={flow.devCode}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
